import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";
import { categoryMap } from "@/mocks/categories";
import { formatHeat } from "@/components/feature/ArticleCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function HeatRank() {
  const sorted = [...articles].sort((a, b) => b.heat - a.heat).slice(0, 8);
  const maxHeat = sorted[0]?.heat ?? 1;
  const medal = ["bg-accent-500", "bg-accent-400", "bg-accent-300"];

  return (
    <section className="bg-background-100 py-12 md:py-16">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          eyebrow="热度排行"
          title="近 30 天热度飙升榜"
          description="综合阅读量、追更数与讨论热度的实时排行，告诉你此刻大家都在追什么。"
        />
        <div className="grid grid-cols-1 gap-3 lg:grid-cols-2">
          {sorted.map((a, i) => {
            const cat = categoryMap[a.category];
            const pct = Math.round((a.heat / maxHeat) * 100);
            return (
              <Link
                key={a.id}
                to={`/article/${a.slug}`}
                className="group flex items-center gap-4 rounded-lg border border-background-200/70 bg-background-50 p-3 transition-transform hover:-translate-y-0.5 md:p-4"
              >
                <span
                  className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-md text-base font-black text-background-50 ${
                    medal[i] ?? "bg-background-400"
                  }`}
                >
                  {i + 1}
                </span>
                <div className="h-14 w-11 shrink-0 overflow-hidden rounded-md bg-background-100">
                  <img
                    src={a.cover}
                    alt={`${a.title}漫画封面`}
                    className="h-full w-full object-cover object-top"
                  />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <h3 className="line-clamp-1 text-sm font-bold text-foreground-950">{a.title}</h3>
                    <span className="whitespace-nowrap text-xs font-semibold text-primary-600">
                      {formatHeat(a.heat)}
                    </span>
                  </div>
                  <div className="mt-1 flex items-center gap-2 text-xs text-foreground-500">
                    <span className="rounded-full bg-secondary-100 px-2 py-0.5 text-secondary-900">
                      {cat?.name ?? "漫画"}
                    </span>
                    <span>{a.rating.toFixed(1)} 分</span>
                  </div>
                  <div className="mt-2 h-1.5 w-full overflow-hidden rounded-full bg-background-100">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-primary-500 to-accent-500"
                      style={{ width: `${pct}%` }}
                    ></div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}